import moment from "moment";
import React from "react";
import _ from "underscore";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaymentConfigRequest } from "../../../store/shopping/shopping.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../../store/user/user.selector";
import { getVIPSubscriptionRequest } from "../../../store/user/vipcircle/vipcircle.actions";
import { getVIPSubscriptions } from "../../../store/user/vipcircle/vipcircle.selector";
import { mySubscriptionData as auctionData } from "../SubscriptionData";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {
    fetchOtherUserProfileRequest,
    searchUserRequest,
} from "../../../store/user/user.actions";
import { getLiveStreams } from "../../../store/social/social.selector";

const SubsVipCrcle = () => {
    const history = useNavigate();
    const dispatch = useDispatch();

    const { vipSubscriptions, userProfile, liveStreams, users } = useSelector(
        (state) => {
            return {
                vipSubscriptions: getVIPSubscriptions(state),
                userProfile: getUserProfile(state),
                liveStreams: getLiveStreams(state),
                users: getSearchedUsers(state),
            };
        }
    );

    useEffect(() => {
        dispatch(getVIPSubscriptionRequest());
        if (users.length === 0) {
            dispatch(searchUserRequest());
        }
    }, []);

    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {vipSubscriptions.map((item) => {
                    let curUser = _.find(
                        item.guests,
                        (s) => s.userId === userProfile._id
                    );
                    let existing = _.find(
                        users,
                        (x) => x._id === item.user._id
                    );
                    let days = moment(curUser.expiredTime).diff(
                        moment(),
                        "days"
                    );
                    if (!existing) {
                        return <span />;
                    }
                    return (
                        <div
                            key={item._id}
                            className="rounded-lg border border-black-10"
                        >
                            <div className="relative">
                                <img
                                    src={getImage(item.avatar)}
                                    alt=""
                                    className="rounded-tl-lg rounded-tr-lg w-full"
                                />
                                <div className="absolute left-0 top-0 right-0 bottom-0 flex flex-col justify-between p-2.5">
                                    <div className="flex items-center">
                                        <img
                                            src={getImage(existing.attachments)}
                                            alt=""
                                            className="w-8 h-8 rounded-full border border-white mr-[7px]"
                                        />
                                        <div className="">
                                            <h5 className="text-sm font-medium text-white">
                                                {existing.fullName}
                                            </h5>
                                            <p className="text-extraSmall text-white/70">
                                                @{existing.account.userName}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="flex items-center text-sm text-white mr-4">
                                            <span className="inline-block mr-[5px]">
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M3.26753 13.8364C4.96056 12.8795 6.9165 12.3333 9 12.3333C11.0835 12.3333 13.0394 12.8795 14.7325 13.8364M11.5 7.33333C11.5 8.71405 10.3807 9.83333 9 9.83333C7.61929 9.83333 6.5 8.71405 6.5 7.33333C6.5 5.95262 7.61929 4.83333 9 4.83333C10.3807 4.83333 11.5 5.95262 11.5 7.33333ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {
                                                    item.guests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Subscribed"
                                                    ).length
                                                }
                                            </span>
                                        </div>
                                        <div className="flex items-center text-sm text-white">
                                            <span className="inline-block mr-[5px]">
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M11.2933 8.30662L8.62892 6.53039C8.07512 6.16119 7.33333 6.55818 7.33333 7.22376V10.7762C7.33333 11.4418 8.07512 11.8388 8.62892 11.4696L11.2933 9.69338C11.788 9.36352 11.788 8.63648 11.2933 8.30662Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                                                        stroke="white"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {liveStreams &&
                                                    liveStreams.filter(
                                                        (x) =>
                                                            x.parent ===
                                                            item._id
                                                    ).length}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="px-3 py-2 border-b border-black-10">
                                    <h3 className="text-base font-bold text-ebony-color">
                                        {item.title}
                                    </h3>
                                    <p className="text-sm font-medium text-black-60">
                                        {item.description}
                                    </p>
                                </div>
                                <div className="px-3 pt-2 pb-4">
                                    <div className="text-sm font-medium text-black space-y-2.5 ">
                                        <div className="flex items-center justify-between">
                                            <p className="capitalize">
                                                Subscribed since:
                                            </p>
                                            <p className="text-black-60">
                                                {moment(
                                                    item.dateCreated
                                                ).fromNow()}
                                            </p>
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <p className="capitalize">
                                                Renew on:
                                            </p>
                                            <p className="text-black-60">
                                                {moment(
                                                    curUser.expiredTime
                                                ).format("DD/MM/YYYY")}
                                            </p>
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <p className="capitalize">Price:</p>
                                            <p className="text-black-60">
                                                {item.currencySubscription}{" "}
                                                {curUser.billingPeriod ===
                                                "monthly"
                                                    ? item.monthlySubscription
                                                    : item.annuallySubscription}{" "}
                                                /{" "}
                                                {curUser.billingPeriod ===
                                                "monthly"
                                                    ? "month"
                                                    : "year"}
                                            </p>
                                        </div>
                                        <div className="mt-2">
                                            {days > 0 ? (
                                                <Button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        dispatch(
                                                            fetchOtherUserProfileRequest(
                                                                item.user._id,
                                                                history
                                                            )
                                                        );
                                                    }}
                                                    fullWidth
                                                    className="m-0"
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    View Circle
                                                </Button>
                                            ) : (
                                                <Button
                                                    onClick={() => {
                                                        dispatch(
                                                            fetchOtherUserProfileRequest(
                                                                item.user._id,
                                                                null
                                                            )
                                                        );
                                                        dispatch(
                                                            fetchPaymentConfigRequest()
                                                        );

                                                        history(
                                                            "/page/vip-subscription-payment",
                                                            {
                                                                state: {
                                                                    VIPCircle:
                                                                        item,
                                                                },
                                                            }
                                                        );
                                                    }}
                                                    fullWidth
                                                    variant="outlined"
                                                    className="bg-danger text-white m-0"
                                                >
                                                    Renew Subscription
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {vipSubscriptions.length === 0 && (
                <div className="flex flex-col items-center justify-start pt-9 width-100-per">
                    <p className="text-sm text-black-50 mb-5">
                        You do not have any active subscriptions
                    </p>
                    <button className="py-2.5 px-[18px] bg-orange-color text-white text-sm font-bold rounded-lg">
                        Start your subscription
                    </button>
                </div>
            )}
        </div>
    );
};

export default SubsVipCrcle;
